import {ListItem} from '../ListItem'
import type {RunViolationItem, RunViolationsData} from '../../../../types/rules-types'
import {SHORT_SHA_LENGTH} from '../../../../helpers/constants'

import styles from './ViolationsList.module.css'

export function ViolationsList({violations, format}: {violations: RunViolationsData; format: 'path' | 'commit'}) {
  const itemCount = violations.items.length
  const totalCount = violations.total

  return (
    <ul>
      {itemCount < totalCount && (
        <div className={styles.ViolationsListSummary}>
          Found {totalCount} violations (showing first {itemCount})
        </div>
      )}
      {violations.items.map((item: RunViolationItem, index: number) => (
        <ListItem
          // eslint-disable-next-line @eslint-react/no-array-index-key
          key={index}
          state={'failure'}
          title={
            format === 'path'
              ? item.candidate?.substring(item.candidate.lastIndexOf('/') + 1) || 'Unknown'
              : item.candidate.toString().slice(0, SHORT_SHA_LENGTH)
          }
          titleClass={format === 'commit' ? 'text-mono' : undefined}
          description={format === 'path' ? item.candidate || 'N/A' : undefined}
          paddingY={1}
        />
      ))}
    </ul>
  )
}
